/* eslint-disable no-debugger */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILobasDigitalAssetDownloadData } from './lobas-digital-asset-download.data';
import { ILobasDigitalAssetDownloadProps } from './lobas-digital-asset-download.props.autogenerated';
import {
    Button,
    getPayloadObject,
    getTelemetryAttributes,
    getTelemetryObject,
    ITelemetryContent
} from '@msdyn365-commerce-modules/utilities';
import { TelemetryEvent } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { IDimensionForSelectedVariant } from '@msdyn365-commerce-modules/retail-actions';
import createDownloadPackage from './methods/createDownloadPackage';

export interface ILobasDigitalAssetDownloadViewProps extends ILobasDigitalAssetDownloadProps<ILobasDigitalAssetDownloadData> {
    lobasDigitalAssetDownloadContainer?: React.ReactNode;
    className?: string;
}

/**
 *
 * LobasDigitalAssetDownload component
 * @extends {React.PureComponent<ILobasDigitalAssetDownloadProps<ILobasDigitalAssetDownloadData>>}
 */
class LobasDigitalAssetDownload extends React.PureComponent<ILobasDigitalAssetDownloadProps<ILobasDigitalAssetDownloadData>> {
    private readonly telemetryContent: ITelemetryContent = getTelemetryObject(
        this.props.context.request.telemetryPageName!,
        this.props.friendlyName,
        this.props.telemetry
    );

    public render(): JSX.Element | null {
        let data: ILobasDigitalAssetDownloadData;

        try {
            data = this.props.data;
        } catch (error) {
            this.props.telemetry.error(`Something went wrong ------${error}`);
            return <div>{error}</div>;
        }

        /*if (!data.productDimensions.result || data.productDimensions.result.length <= 0) {
            this.props.telemetry.error('Product dimensions content is empty, module wont render.');
            return null;
        }*/

        const viewProps = {
            ...this.props,
            lobasDigitalAssetDownloadContainer: this._createDownloadContainer(data),
            className: this.props.config.className
        } as ILobasDigitalAssetDownloadViewProps;

        return this.props.renderView(viewProps);
    }

    private _createButton(): JSX.Element {
        const payload = getPayloadObject(TelemetryEvent.ProductPageView, this.telemetryContent, this.props.resources.downloadLabel, '');
        const attributes = getTelemetryAttributes(this.telemetryContent, payload);

        return (
            <Button
                className={'lobas-digital-asset-download__btn'}
                color='primary'
                onClick={_onClick(
                    this.props.data.product.result,
                    this.props.data.productDimensions.result,
                    this.props.context.request.apiSettings.baseImageUrl
                )}
                title={this.props.resources.downloadLabel}
                {...attributes}
            >
                {this.props.resources.downloadLabel}
            </Button>
        );
    }

    private _createDownloadContainer(content: ILobasDigitalAssetDownloadData): JSX.Element | null {
        return <div className={'lobas-digital-asset-download__container'}>{this._createButton()}</div>;
    }
}

const _onClick = (
    _product: SimpleProduct | undefined,
    _productDimensions: IDimensionForSelectedVariant[] | undefined,
    _baseImageUrl: string | undefined
) => async () => {
    await createDownloadPackage(_product, _productDimensions, _baseImageUrl);
};

export function getTelemetryContent(props: ILobasDigitalAssetDownloadProps<ILobasDigitalAssetDownloadData>): ITelemetryContent {
    return getTelemetryObject(props.context.request.telemetryPageName!, props.friendlyName, props.telemetry);
}

export default LobasDigitalAssetDownload;
